// src/components/ProjectChat.tsx
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChatAPI, FileAPI } from "../api/apiClient";
import { createSignalRConnection } from "../api/signalRClient";
import * as signalR from "@microsoft/signalr";

/* ---------------------------
   TYPES
---------------------------- */
type Msg = {
  messageNo?: number;   // ADD THIS
  message: string;
  theUser?: number;
  sender?: string;
  sentAt?: string | number | Date;
  messageDate?: string | number | Date;
  editedAt?: string;    // add
  isDeleted?: boolean;  // add
  tempId?: number;
};

type GroupedMessages = {
  dateLabel: string;
  items: Msg[];
};

/* ---------------------------
   HELPERS
---------------------------- */
function getDateLabel(dateStr: string | number | Date): string {
  const msgDate = new Date(
    typeof dateStr === "string" && !dateStr.endsWith("Z")
      ? dateStr + "Z"
      : dateStr
  );

  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  if (msgDate.toDateString() === today.toDateString()) return "Today";
  if (msgDate.toDateString() === yesterday.toDateString()) return "Yesterday";

  return msgDate.toLocaleDateString([], {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

function groupMessages(messages: Msg[]): GroupedMessages[] {
  const groups: Record<string, Msg[]> = {};
  for (const msg of messages) {
    const label = getDateLabel(msg.sentAt || msg.messageDate || new Date());
    if (!groups[label]) groups[label] = [];
    groups[label].push(msg);
  }

  return Object.entries(groups).map(([dateLabel, items]) => ({
    dateLabel,
    items,
  }));
}

/* ---------------------------
   MAIN COMPONENT
---------------------------- */
export default function ProjectChat({ projectId }: { projectId: number }) {
  const navigate = useNavigate();

  const [messages, setMessages] = useState<Msg[]>([]);
  const [text, setText] = useState("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [menuMessage, setMenuMessage] = useState<number | null>(null);
  const [editingMessage, setEditingMessage] = useState<number | null>(null);
const [editText, setEditText] = useState("");
const [pressTimer, setPressTimer] = useState<NodeJS.Timeout | null>(null);
const [deleteTarget, setDeleteTarget] = useState<Msg | null>(null);
  const [connection, setConnection] =
    useState<signalR.HubConnection | null>(null);

  const [currentUser, setCurrentUser] = useState<{
    userNo: number;
    userName: string;
  } | null>(null);

  const messagesEndRef = useRef<HTMLDivElement | null>(null);

  /* ---------------------------
     Load user
  ---------------------------- */
  useEffect(() => {
    const stored = localStorage.getItem("user");
    if (stored) {
      try {
        const u = JSON.parse(stored);
        setCurrentUser({
          userNo: u.userNo ?? u.UserNo,
          userName: u.userName ?? u.UserName,
        });
      } catch {}
    }
  }, []);

  /* Scroll to bottom */
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  /* Load history */
 /* const loadMessages = async (pid: number) => {
    const data = await ChatAPI.getProjectChat(pid);

    const normalized = data.map((m: any) => ({
      ...m,
      sender: m.sender?.userName ?? m.sender ?? "Unknown",
    }));

    setMessages(normalized);
  };*/
  const loadMessages = async (pid: number) => {
  const data = await ChatAPI.getProjectChat(pid);

  /*const normalized = data.map((m: any) => ({
    messageNo: m.messageNo ?? m.MessageNo,
    message: m.message ?? m.Message,
    isDeleted: m.isDeleted ?? m.IsDeleted,
    editedAt: m.editedAt ?? m.EditedAt,
    sentAt: m.sentAt ?? m.SentAt,
    messageDate: m.messageDate ?? m.MessageDate,
    //theUser: m.theUser ?? m.TheUser,
    theUser: Number(m.theUser ?? m.TheUser),
    sender: m.sender?.userName ?? m.Sender?.UserName ?? "Unknown"
  }));*/
 /*const normalized = data.map((m: any) => ({
  messageNo: m.messageNo,
  message: m.message,
  isDeleted: m.isDeleted,
  editedAt: m.editedAt,
  sentAt: m.sentAt,
  messageDate: m.messageDate,
 
theUser: Number(m.theUser ?? m.userNo),
 
     sender: m.Sender?.UserName ?? m.sender?.userName ?? "Unknown"
}));*/
const normalized = data.map((m: any) => ({
  messageNo: m.messageNo ?? m.MessageNo,
  message: m.message ?? m.Message,
  isDeleted: m.isDeleted ?? m.IsDeleted ?? false,
  editedAt: m.editedAt ?? m.EditedAt,
  sentAt: m.sentAt ?? m.SentAt,
  messageDate: m.messageDate ?? m.MessageDate,

  // sender user id
  theUser: Number(m.theUser ?? m.TheUser ?? m.UserNo ?? m.sender?.userNo ?? 0),

  // sender username
  sender:
    m.userName ??
    m.UserName ??
    m.Sender?.UserName ??
    m.sender?.userName ??
    m.Sender?.userName ??
    "Unknown",
}));
  setMessages(normalized);
};

  /* ---------------------------
     SignalR
  ---------------------------- */
  useEffect(() => {
    if (!projectId) return;

    loadMessages(projectId);

    const conn = createSignalRConnection();
    setConnection(conn);

    conn
      .start()
      .then(() => {
        conn.invoke("JoinProject", projectId);

        /*conn.on(
          "ReceiveProjectMessage",
          (
            projId: number,
            userNo: number,
            userName: string,
            text: string,
            sentAt: string
          ) => {
            if (projId !== projectId) return;

            setMessages((prev) => {
              const withoutOptimistic = prev.filter(
                (m) =>
                  !(m.tempId && m.message === text && m.theUser === userNo)
              );

              return [
                ...withoutOptimistic,
                {
                   //messageNo: Date.now(),   // temporary id
                  message: text,
                  theUser: userNo,
                  sender: userName,
                  sentAt,
                },
              ];
            });
          }
        );*/
        conn.on(
  "ReceiveProjectMessage",
  (
    projId: number,
    messageNo: number,
    userNo: number,
    userName: string,
    text: string,
    sentAt: string
  ) => {

    if (projId !== projectId) return;

   /* setMessages(prev => {

      // prevent duplicate messages
      if (prev.some(m => m.messageNo === messageNo)) {
        return prev;
      }*/

      /*return [
        ...prev,
        {
          messageNo,
          message: text,
          theUser: userNo,
          sender: userName,
          sentAt
        }
      ];*/
      /*return [...prev, {
  messageNo,
  message: text,
 // theUser: userNo,
 theUser: Number(userNo),
  sender: userName,
  sentAt
}].sort((a, b) =>
  new Date(a.sentAt || 0).getTime() -
  new Date(b.sentAt || 0).getTime()
);
    });*/

    setMessages(prev => {

  // prevent duplicate messages
  if (prev.some(m => m.messageNo === messageNo)) {
    return prev;
  }

  // remove optimistic temp message
  const withoutTemp = prev.filter(
    m => !(m.tempId && m.message === text)
  );

  return [...withoutTemp, {
    messageNo,
    message: text,
    theUser: Number(userNo ?? currentUser?.userNo),
    sender: userName,
    sentAt
  }].sort((a, b) =>
    new Date(a.sentAt || 0).getTime() -
    new Date(b.sentAt || 0).getTime()
  );

});
    setMenuMessage(null);   // ⭐ add this
  }
);

        /* EDIT MESSAGE EVENT */
conn.on(
  "ProjectMessageEdited",
  (
    projId: number,
    messageNo: number,
    newText: string,
    userNo: number,
    userName: string,
    sentAt: string
  ) => {

    if (projId !== projectId) return;

    setMessages(prev =>
      prev.map(m =>
        Number(m.messageNo) === Number(messageNo)
          ? {
              ...m,
              message: newText,
              editedAt: sentAt,
              //theUser: userNo,
              theUser: Number(userNo),
              sender: userName
            }
          : m
      )
    );
    setMenuMessage(null);   // ⭐ ADD THIS LINE
  }
);

/* DELETE MESSAGE EVENT */
conn.on(
  "ProjectMessageDeleted",
  (
    projId: number,
    messageNo: number,
    userNo: number,
    userName: string
  ) => {

    if (projId !== projectId) return;

    setMessages(prev =>
      prev.map(m =>
        Number(m.messageNo) === Number(messageNo)
          ? {
              ...m,
              isDeleted: true,
              //theUser: userNo,
              theUser: Number(userNo),
              sender: userName
            }
          : m
      )
    );
    setMenuMessage(null);   // ⭐ ADD THIS LINE
  }
);
      })
      .catch(console.error);

    return () => {
      conn.off("ReceiveProjectMessage");

      conn.off("ProjectMessageEdited");
      conn.off("ProjectMessageDeleted");
      conn.stop();
    };
  }, [projectId]);

  /* ---------------------------
     Send Message
  ---------------------------- */
  const handleSend = async () => {
    if (!currentUser) return;

    try {
      let finalMessage = text;

      if (selectedFile) {
        const uploaded = await FileAPI.upload(
          selectedFile,
          currentUser.userNo,
          undefined,
          projectId
        );

        const fileMessage = `[FILE]|${uploaded.fileUrl}|${uploaded.originalFileName}|${uploaded.fileSizeBytes}`;

        finalMessage = text.trim()
          ? `${fileMessage}\n${text}`
          : fileMessage;

        setSelectedFile(null);
      }

      if (!finalMessage.trim()) return;

      const tempMessage: Msg = {
        //messageNo: Date.now(),
        message: finalMessage,
        theUser: currentUser.userNo,
        sender: currentUser.userName,
        sentAt: new Date().toISOString(),
        tempId: Date.now(),
      };

      // Show instantly
      setMessages((prev) => [...prev, tempMessage]);
      setText("");

      const res: any = await ChatAPI.postProjectMessage(projectId, finalMessage);
      connection?.invoke(
  "SendProjectMessage",
  projectId,
  finalMessage,
  currentUser.userNo
).catch(console.error);
      // Notify SignalR immediately
      /*connection?.invoke(
        "SendProjectMessage",
        projectId,
        finalMessage,
        currentUser.userNo
      ).catch(console.error);*/

      // Save in background
      //ChatAPI.postProjectMessage(projectId, finalMessage)
// Save in DB and get real MessageNo
//const res: any = await ChatAPI.postProjectMessage(projectId, finalMessage);
// Replace temp message with real DB id
setMessages(prev =>
  prev.map(m =>
    m.tempId === tempMessage.tempId
      ? { ...m, messageNo: res.messageNo }
      : m
  )
);

       // .catch(console.error);

    } catch (err) {
      console.error("Send failed:", err);
    }
  };

  /* ---------------------------
   EDIT MESSAGE
---------------------------- */
/*const handleEdit = async (msg: Msg) => {

  const newText = prompt("Edit message", msg.message || "");

  if (!newText || !msg.messageNo || msg.isDeleted) return;

  try {

    setMessages(prev =>
      prev.map(m =>
        m.messageNo === msg.messageNo
          ? { ...m, message: newText, editedAt: new Date().toISOString() }
          : m
      )
    );

    await ChatAPI.editProjectMessage(projectId, msg.messageNo, newText);

    connection?.invoke(
      "EditProjectMessage",
      projectId,
      msg.messageNo,
      newText,
      currentUser?.userNo
    );
//await loadMessages(projectId);
  } catch (err) {
    console.error("Edit failed:", err);
  }
};*/

const handleEdit = (msg: Msg) => {

  if (!msg.messageNo || msg.isDeleted) return;

  setEditingMessage(msg.messageNo);
  setEditText(msg.message);
  setMenuMessage(null);
};
const saveEdit = async (msg: Msg) => {

  if (!msg.messageNo) return;

  try {

    setMessages(prev =>
      prev.map(m =>
        m.messageNo === msg.messageNo
          ? { ...m, message: editText, editedAt: new Date().toISOString() }
          : m
      )
    );

    await ChatAPI.editProjectMessage(projectId, msg.messageNo, editText);

    connection?.invoke(
      "EditProjectMessage",
      projectId,
      msg.messageNo,
      editText,
      currentUser?.userNo
    );

    setEditingMessage(null);
    setEditText("");

  } catch (err) {
    console.error("Edit failed:", err);
  }
};


/* ---------------------------
   DELETE MESSAGE
---------------------------- */
const handleDelete = async (msg: Msg) => {

  if (!msg.messageNo || msg.isDeleted) return;

  //if (!window.confirm("Delete this message?")) return;

  try {

    setMessages(prev =>
      prev.map(m =>
        m.messageNo === msg.messageNo
          ? { ...m, isDeleted: true }
          : m
      )
    );

    await ChatAPI.deleteProjectMessage(projectId, msg.messageNo);

    connection?.invoke(
      "DeleteProjectMessage",
      projectId,
      msg.messageNo,
      currentUser?.userNo
    );
//await loadMessages(projectId);
  } catch (err) {
    console.error("Delete failed:", err);
  }
};

  const grouped = groupMessages(messages);

  // Allow edit only for 15 minutes
const canEditMessage = (msg: Msg) => {

  const rawTime = msg.sentAt || msg.messageDate;
  if (!rawTime) return false;

  const messageTime = new Date(rawTime).getTime();
  const now = Date.now();

  const diffMinutes = (now - messageTime) / (1000 * 60);

  return diffMinutes <= 15;
};

  /* ---------------------------
   MOBILE LONG PRESS MENU
---------------------------- */

const handleTouchStart = (msgNo?: number) => {

  const timer = setTimeout(() => {
    if (msgNo) setMenuMessage(msgNo);
  }, 600); // 600ms press

  setPressTimer(timer);
};

const handleTouchEnd = () => {
  if (pressTimer) clearTimeout(pressTimer);
};

  /* ---------------------------
     UI
  ---------------------------- */
  return (
    //<div className="flex flex-col h-full bg-gray-50">
    //<div className="flex flex-col h-full bg-gray-50"
     <div className=" flex flex-col h-full min-h-0 bg-gray-50 overflow-hidden overflow-x-hidden"
  onClick={() => setMenuMessage(null)}>

      {/*<div className="flex-1 overflow-y-auto p-4 bg-gray-100">*/}
      
      {/*<div className="flex-1 overflow-y-auto px-4 py-2 bg-gray-100">*/}
      <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden px-4 py-3 pb-10 bg-gray-100">
        {grouped.map((group, idx) => (
          <div key={idx}>
            <div className="text-center text-xs text-gray-500 my-4">
              <span className="bg-gray-200 px-3 py-1 rounded-full">
                {group.dateLabel}
              </span>
            </div>

           {/* {group.items.map((m, midx) => { */}
            {/*{group.items.map((m) => {*/}
            {group.items.map((m: Msg) => {
              /*const isMine =
                currentUser &&
                (m.theUser === currentUser.userNo ||
                  m.sender === currentUser.userName);*/
               const isMine =
  !!currentUser && Number(m.theUser) === Number(currentUser.userNo);

              const rawTime = m.sentAt || m.messageDate;

              const when = rawTime
                ? new Date(
                    typeof rawTime === "string" && !rawTime.endsWith("Z")
                      ? rawTime + "Z"
                      : rawTime
                  ).toLocaleTimeString("en-IN", {
                    timeZone: "Asia/Kolkata",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })
                : "";

              return (
                <div key={m.messageNo ?? m.tempId}
                 // key={midx}
                 
                  className={`flex mb-3 ${
                    isMine ? "justify-end" : "justify-start"
                  }`}
                >
                  {/*<div
                    className={`max-w-[70%] p-3 rounded-2xl shadow-sm ${
                      isMine
                        ? "bg-green-600 text-white rounded-br-none"
                        : "bg-white text-gray-800 rounded-bl-none"
                    }`} 
                  >*/}
                 {/* <div   onClick={(e) => e.stopPropagation()}
  className={`relative max-w-[70%] p-3 rounded-2xl shadow-sm ${
    isMine
      ? "bg-green-600 text-white rounded-br-none"
      : "bg-white text-gray-800 rounded-bl-none"
  }`}
>*/}
{/*<div
  onClick={(e) => e.stopPropagation()}
  className={`relative max-w-[70%] p-3 rounded-2xl shadow-sm ${
    editingMessage === m.messageNo
      ? "bg-yellow-100 text-black"
      : isMine
      ? "bg-green-600 text-white rounded-br-none"
      : "bg-white text-gray-800 rounded-bl-none"
  }`}
>*/}
<div
  onClick={(e) => e.stopPropagation()}
  onTouchStart={() => handleTouchStart(m.messageNo)}
  onTouchEnd={handleTouchEnd}
  onMouseDown={() => handleTouchStart(m.messageNo)}
  onMouseUp={handleTouchEnd}
  className={`relative max-w-[70%] p-3 rounded-2xl shadow-sm ${
    editingMessage === m.messageNo
      ? "bg-yellow-100 text-black"
      : isMine
      ? "bg-green-600 text-white rounded-br-none"
      : "bg-white text-gray-800 rounded-bl-none"
  }`}
>



                   {/* {isMine && !m.isDeleted && !m.message?.startsWith("[FILE]") && (
  <div className="flex justify-end gap-2 text-xs mb-1">
    <button onClick={() => handleEdit(m)}>Edit</button>
    <button onClick={() => handleDelete(m)}>Delete</button>
  </div>
)}*/}
{isMine && !m.isDeleted && !m.message?.startsWith("[FILE]") && (
  <div className="absolute top-1 right-2">
    <button
      onClick={(e) => {
        e.stopPropagation();
       // setMenuMessage(menuMessage === m.messageNo ? null : m.messageNo || null);
       setMenuMessage(
  menuMessage === Number(m.messageNo)
    ? null
    : Number(m.messageNo)
);
      }}
      className="opacity-70 hover:opacity-100" //className="text-white opacity-70 hover:opacity-100"
    >
      ⋮ 
       
    </button>
  </div>
)}
{/*{menuMessage === m.messageNo && (*/}
{menuMessage === Number(m.messageNo) && (
  <div
    className="absolute top-7 right-2 bg-white shadow-lg rounded-md text-sm text-gray-700 z-50"
    onClick={(e) => e.stopPropagation()}
  >
   {/* <button
      onClick={() => {
        handleEdit(m);
        setMenuMessage(null);
      }}
      className="block px-4 py-2 hover:bg-gray-100 w-full text-left"
    >
      ✏️ Edit
    </button>*/}
    {canEditMessage(m) && (
  <button
    onClick={() => {
      handleEdit(m);
      setMenuMessage(null);
    }}
    className="block px-4 py-2 hover:bg-gray-100 w-full text-left"
  >
    ✏️ Edit
  </button>
)}

    {/*<button
      onClick={() => {
        handleDelete(m);
        setMenuMessage(null);
      }}
      className="block px-4 py-2 hover:bg-gray-100 w-full text-left"
    >
      🗑 Delete
    </button>
  </div>
)}*/}
<button
  onClick={() => {
    setDeleteTarget(m);
    setMenuMessage(null);
  }}
  className="block px-4 py-2 hover:bg-gray-100 w-full text-left"
>
  🗑 Delete
</button>
</div>
)}


                    {!isMine && (
                      <div className="text-xs font-semibold mb-1 flex justify-between text-gray-600">
                        <span>{m.sender}</span>
                        <span className="text-[10px] opacity-70">
                          {when}
                        </span>
                      </div>
                    )}

                    {isMine && (
                      <div className="text-[10px] text-right opacity-75 mb-1">
                        {when}
                      </div>
                    )}

                    {/* FILE PARSING */}
                    <div className="text-sm leading-snug">
                      {m.message?.startsWith("[FILE]") ? (() => {
                        const [filePart, ...captionParts] = m.message.split("\n");
                        const parts = filePart.replace("[FILE]|", "").split("|");

                        const fileUrl = parts[0];
                        const fileName =
                          parts[1] || fileUrl.split("/").pop();
                        const fileSize = parts[2];

                        const caption = captionParts.join("\n");

                        const fullUrl =
                          `${process.env.REACT_APP_API_BASE?.replace("/api", "")}${fileUrl}`;

                        const sizeInKB = fileSize
                          ? (parseInt(fileSize) / 1024).toFixed(1)
                          : null;

                        return (
                          <div className="flex flex-col gap-2">
                            <a
                              href={fullUrl}
                              target="_blank"
                              rel="noreferrer"
                              className="flex items-center gap-3 bg-gray-100 p-3 rounded-xl hover:bg-gray-200 transition"
                            >
                              <div className="text-2xl">📎</div>

                              <div className="flex flex-col">
                                <span className="font-medium text-gray-800">
                                  {fileName}
                                </span>
                                {sizeInKB && (
                                  <span className="text-xs text-gray-500">
                                    {sizeInKB} KB
                                  </span>
                                )}
                              </div>
                            </a>

                            {caption && (
                              <div className="text-sm">{caption}</div>
                            )}
                          </div>
                        );
                      /*})() : (
                        m.message
                      )}*/
                     })() : m.isDeleted ? (
  <span className="italic text-gray-400">
    This message was deleted
  </span>
) : (
 
  /*editingMessage === Number(m.messageNo) ? (

  <div className="flex gap-2 items-center">

    <input
      value={editText}
      onChange={(e) => setEditText(e.target.value)}
      className="border rounded px-2 py-1 text-black flex-1"
      autoFocus
    />

    <button
      onClick={() => saveEdit(m)}
      className="text-xs bg-green-600 text-white px-2 py-1 rounded"
    >
      Save
    </button>

    <button
      onClick={() => setEditingMessage(null)}
      className="text-xs bg-gray-300 px-2 py-1 rounded"
    >
      Cancel
    </button>

  </div>

) : (*/
 /*editingMessage === Number(m.messageNo) ? (

  <div className="flex flex-col gap-2 w-full">

    <textarea
      value={editText}
      onChange={(e) => setEditText(e.target.value)}
      className="border rounded px-2 py-1 text-black text-sm w-full resize-none"
      rows={3}
      autoFocus
    />

    <button
      onClick={() => saveEdit(m)}
      //className="text-xs bg-green-600 text-white px-3 py-1 rounded w-full"
      className="text-xs bg-green-600 text-white px-3 py-1 rounded"
    >
      Save
    </button>

    <button
      onClick={() => setEditingMessage(null)}
      //className="text-xs bg-gray-300 px-3 py-1 rounded w-full"
      className="text-xs bg-gray-300 px-3 py-1 rounded"
    >
      Cancel
    </button>

  </div>

) : ( */
 editingMessage === Number(m.messageNo) ? (

  <div className="flex flex-col gap-2 w-full">

    <textarea
      value={editText}
      onChange={(e) => setEditText(e.target.value)}
      className="border rounded px-2 py-1 text-black text-sm w-full resize-none"
      rows={3}
      autoFocus
    />

    <div className="flex flex-col gap-2 w-full">

      <button
        onClick={() => saveEdit(m)}
        className="text-xs bg-green-600 text-white py-1 rounded w-full"
      >
        Save
      </button>

      <button
        onClick={() => setEditingMessage(null)}
        className="text-xs bg-gray-300 py-1 rounded w-full"
      >
        Cancel
      </button>

    </div>

  </div>

) : (

  <>
    {m.message}
    {m.editedAt && (
      <span className="text-[10px] opacity-60 ml-2">
        (edited)
      </span>
    )}
  </>

))
}


{/*)}  */}
                    </div>
                  </div>
                </div>
              );
            })}

            <div ref={messagesEndRef} />
          </div>
        ))}
      </div>


        {/* Delete Modal */}
{deleteTarget && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

    <div className="bg-white rounded-xl shadow-lg p-6 w-80">

      <h3 className="text-lg font-semibold mb-3">
        Delete message
      </h3>

      <p className="text-sm text-gray-600 mb-5">
        Are you sure you want to delete this message?
      </p>

      <div className="flex justify-end gap-3">

        <button
          onClick={() => setDeleteTarget(null)}
          className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
        >
          Cancel
        </button>

        <button
          onClick={() => {
            handleDelete(deleteTarget);
            setDeleteTarget(null);
          }}
          className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700"
        >
          Delete
        </button>

      </div>

    </div>

  </div>
)}









      {/* Input */}
     {/* <div className="bg-white border-t px-3 pt-3 pb-8 flex gap-2 items-center">*/}
     <div className="bg-white border-t px-3 py-2 flex gap-2 items-center overflow-x-hidden">
        <input
          type="file"
          id="projectFileUpload"
          className="hidden"
          onChange={(e) => {
            if (e.target.files && e.target.files[0]) {
              setSelectedFile(e.target.files[0]);
              e.target.value = "";
            }
          }}
        />

        <button
          type="button"
          onClick={() =>
            document.getElementById("projectFileUpload")?.click()
          }
          className="px-3 py-2 bg-gray-200 rounded-full hover:bg-gray-300"
        >
          📎
        </button>

        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSend();
            }
          }}
          placeholder={
            selectedFile ? selectedFile.name : "Type a message..."
          }
          //className="flex-1 border px-3 py-2 rounded-lg"
          className="flex-1 min-w-0 border px-3 py-2 rounded-lg"
        />

        <button
          onClick={handleSend}
          disabled={!text.trim() && !selectedFile}
          className={`px-5 py-2 rounded-lg transition ${
            text.trim() || selectedFile
              ? "bg-green-600 text-white hover:bg-green-700"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }`}
        >
          Send
        </button>
      </div>
    </div>
  );
}